import { useAppDispatch, useAppSelector } from "stores";
import { initUserSessionAction } from "stores/Auth";
import { loadAccessToken } from "utils";

const useAuth = () => {
  const dispatch = useAppDispatch();
  const { userProfileFetching, userProfileInitializing, status, userProfile } =
    useAppSelector((state) => state.auth);

  const initUserSession = () => {
    const accessToken = loadAccessToken();
    if (!accessToken) return;
    dispatch(initUserSessionAction());
  };

  const isLoggedIn = status === "AUTH";

  return {
    isLoggedIn,
    data: userProfile,
    isInitializing: userProfileInitializing,
    isFetching: userProfileFetching,
    initUserSession,
  };
};

export default useAuth;
